import { CssBaseline, Grid, Drawer, useMediaQuery, useTheme, IconButton } from "@mui/material";
import React, { Suspense, useState } from "react";

import MainRoutes from "../../Routes/main";
import Header from "../shared/Header";
import SuspenseFallback from "../shared/SuspenseFallback";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import useStyles from "./style.js";

export default function App({ isLoggedIn }) {
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isMd = useMediaQuery(theme.breakpoints.down("md"));
  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* Sidebar for small screens */}
      {isMd && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <Header handleDrawerToggle={handleDrawerToggle} />
        </Drawer>
      )}

      {/* Top Header Bar */}
      <Grid container spacing={0}>
        {isMd ? (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            style={{
              position: "fixed",
              top: -12,
              right: -10,
              zIndex: 20,
              backgroundColor: theme.palette.loginSignUpSubscriptionBG,
              padding: 28,
            }}
          >
            {mobileOpen ? (
              <CloseIcon sx={{ position: "absolute" }} />
            ) : (
              <MenuIcon sx={{ position: "absolute" }} />
            )}
          </IconButton>
        ) : (
          <Grid item className={isMd ? classes.mdAppIconMenu : classes.fullAppIconMenu}>
            <Header handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} />
          </Grid>
        )}
        <Grid
          style={{
            width: isMd ? "100%" : "95.5344%",
          }}
          className={classes.main}
          item
        >
          <main>
            <Suspense fallback={<SuspenseFallback />}>
              <div style={{ minHeight: 360 }}>
                <MainRoutes isLoggedIn={isLoggedIn} />
              </div>
            </Suspense>
          </main>
        </Grid>
      </Grid>
    </div>
  );
}
